// src/components/Common-components/Modal/CommonModal.jsx
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../../../css/Common-components/Modal/modal.css';

/**
 * @param {React.ReactNode} trigger - 모달을 여는 트리거로 사용될 리액트 컴포넌트. (예: <button>, <a>, 커스텀 컴포넌트 등)
 * @param {string} title - 모달의 제목.
 * @param {React.ReactNode} children - 모달의 본문에 표시될 내용.
 * @param {boolean} [showFooter=true] - 푸터 표시 여부. 기본값은 true.
 * @param {Array<object>} [footerButtons] - 푸터에 동적으로 생성할 버튼 설정 배열.
 * @param {string} footerButtons[].text - 버튼에 표시될 텍스트.
 * @param {string} footerButtons[].variant - react-bootstrap 버튼의 variant. (예: 'primary', 'secondary')
 * @param {function} footerButtons[].onClick - 버튼 클릭 시 실행될 함수.
 */


// 사용 예시 1: 간단한 텍스트 트리거와 기본 푸터 사용
// <CommonModal
//   trigger={<button className="my-custom-class">모달 열기</button>}
//   title="기본 모달"
// >
//   <p>모달 내용입니다.</p>
// </CommonModal>

// 사용 예시 2: 커스텀 푸터 콘텐츠와 함께 사용
// const myCustomFooter = (
//   <div>
//     <button onClick={() => console.log('커스텀 버튼 클릭!')}>커스텀 버튼</button>
//     <span>추가 텍스트</span>
//   </div>
// );
//
// <CommonModal
//   trigger={<a href="#">고급 설정</a>}
//   title="고급 설정"
//   showFooter={true}
//   customFooterContent={myCustomFooter}
// >
//   <p>다양한 설정을 변경할 수 있습니다.</p>
// </CommonModal>

// 사용 예시 3: 푸터 없이 내용만 표시
// <CommonModal
//   trigger={<img src="/icons/info.svg" alt="정보" />}
//   title="안내"
//   showFooter={false}
// >
//   <p>이 모달은 푸터가 없습니다.</p>
// </CommonModal>

// 사용 예시 4: 함수를 이용해 푸터 컨텐츠를 만들고 모달 닫기 기능 사용
// <CommonModal
//   trigger={<button>모달 열기</button>}
//   title="함수형 푸터"
//   showFooter={true}
//   customFooterContent={({ handleClose }) => (
//     <button onClick={() => {
//       console.log('할 일 하고 모달 닫기');
//       handleClose();
//     }}>
//       확인 및 닫기
//     </button>
//   )}
// >
//   <p>확인 버튼을 누르면 콘솔 로그를 찍고 모달이 닫힙니다.</p>
// </CommonModal>

export default function CommonModal({ trigger, title, children, showFooter = true, customFooterContent }) {
  const [show, setShow] = useState(false);
  const handleShow  = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      {React.cloneElement(trigger, { onClick: handleShow })}

      <Modal
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        {/* ★ 여기에 컨테이너 타입을 선언 ★ */}
        <Modal.Body>
          <div className="modal-content-container">
            {children}
          </div>
        </Modal.Body>

        {showFooter && (
          <Modal.Footer>
            {customFooterContent ? (
              typeof customFooterContent === "function"
                ? customFooterContent({ handleClose })
                : customFooterContent
            ) : (
              <>
                <Button variant="" onClick={handleClose}>닫기</Button>
              </>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}